import isEmpty from 'lodash/isEmpty';
import { useSelector } from 'react-redux';
import {
  Container,
  CustomerDetailsFormContainer,
  CustomerDetailsFormHeader,
} from './DTReplaceItemAndCustomerDetailsWidget.styles';
import CustomerDetailsField from './CustomerDetailsField/CustomerDetailsField';
import { getCustomerDetails } from 'extractFromState';
import { getSelectedProduct } from 'selectors/tools';

const DTReplaceItemAndCustomerDetailsWidget = () => {
  const customerDetails = useSelector(getCustomerDetails);
  const selectedProduct = useSelector(getSelectedProduct);

  return (
    <Container>
      <CustomerDetailsFormContainer>
        <CustomerDetailsFormHeader>Replacement Details</CustomerDetailsFormHeader>
        {customerDetails.firstName && (
          <CustomerDetailsField label={'First Name'} text={customerDetails.firstName} testId={'firstName'} />
        )}
        {customerDetails.lastName && (
          <CustomerDetailsField label={'Last Name'} text={customerDetails.lastName} testId={'lastName'} />
        )}
        {customerDetails.email && (
          <CustomerDetailsField label={'Email'} text={customerDetails.email} testId={'email'} />
        )}
        {customerDetails.phoneNumber && (
          <CustomerDetailsField label={'Phone Number'} text={customerDetails.phoneNumber} testId={'phoneNumber'} />
        )}
        {customerDetails.addressLineOne && (
          <CustomerDetailsField
            label={'Address Line 1'}
            text={customerDetails.addressLineOne}
            testId={'addressLineOne'}
          />
        )}
        {customerDetails.addressLineTwo && (
          <CustomerDetailsField
            label={'Address Line 2'}
            text={customerDetails.addressLineTwo}
            testId={'addressLineTwo'}
          />
        )}
        {customerDetails.city && <CustomerDetailsField label={'City'} text={customerDetails.city} testId={'city'} />}
        {customerDetails.state && (
          <CustomerDetailsField label={'State'} text={customerDetails.state} testId={'state'} />
        )}
        {customerDetails.zipCode && (
          <CustomerDetailsField label={'Zip Code'} text={customerDetails.zipCode} testId={'zipCode'} />
        )}
        {customerDetails.country && (
          <CustomerDetailsField label={'Country'} text={customerDetails.country} testId={'country'} />
        )}
        {!isEmpty(selectedProduct) && (
          <CustomerDetailsField label={'Item'} text={selectedProduct.title} testId={'item'} />
        )}
      </CustomerDetailsFormContainer>
    </Container>
  );
};

export default DTReplaceItemAndCustomerDetailsWidget;
